/* eslint-disable no-magic-numbers */
/* eslint-disable multiline-ternary */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable arrow-body-style */
/* eslint-disable no-useless-escape */
/* eslint-disable require-unicode-regexp */
/* eslint-disable prefer-named-capture-group */
/* eslint-disable prefer-destructuring */
import { CSSProperties, ReactElement, useContext, useState } from "react";
import { useCSVReader } from "react-papaparse";
import API from "../../services/API";
import "./AddTestUsers.scss";
import Button from "@atlaskit/button";
import { Loader } from "../../components/Loader/Loader";
import { MessageContext } from "../../contexts/Message/MessageContext";

const styles = {
    csvReader: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 10,
    } as CSSProperties,
    browseFile: {
        width: "20%",
        height: 30,
    } as CSSProperties,
    acceptedFile: {
        border: "1px solid #ccc",
        lineHeight: 2.5,
        paddingLeft: 10,
        width: "80%",
        height: 30,
    } as CSSProperties,
    remove: {
        borderRadius: 0,
        padding: "0 20px",
        height: 30,
    } as CSSProperties,
    progressBarBackgroundColor: {
        backgroundColor: "#0052CC",
    } as CSSProperties,
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

interface CSVData {
    "E-Mail-Adresse": string;
    Name: string;
    Vorname: string;
    "Deine Krankenkasse?": string;
}

interface ServerCSVData {
    email: string;
    lastName: string;
    firstName: string;
    userInputedInsuranceName: string;
}
// duplicated in backend user dto

export default function AddTestUsers({}: Props): ReactElement {
    const { CSVReader } = useCSVReader();
    const [failedEmail, setFailedEmail] = useState<string | null>(null);
    const [testUsers, setTestUsers] = useState<ServerCSVData[]>([]);
    const [loading, setIsLoading] = useState(false);
    const messageContext = useContext(MessageContext);
    const isEmail = (emailAdress: string) => {
        const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (emailAdress.match(regex)) {
            return true;
        }
        return false;
    };

    return (
        <div className="form-wrapper-add-test-users">
            <div className="form-date-picker">
                <div className="cont">
                    <div>
                        <h1>CSV mit Testbenutzern hochladen </h1>
                        <br />
                        <br />
                        <div>
                            Es werden nur CSV-Dateien akzeptiert mit folgenden
                            Spaltennamen und dieser Reihenfolge:
                            <br />
                            <br />
                            Submission Date, Form Title, Name, Vorname,
                            E-Mail-Adresse, Ich bin, Deine Krankenkasse?
                        </div>
                        <br />
                        <br />
                        <br />

                        <CSVReader
                            config={{ header: true }}
                            onUploadAccepted={(results: {
                                data: CSVData[];
                            }) => {
                                const serverResults: ServerCSVData[] =
                                    results.data.map(
                                        (result: CSVData): ServerCSVData => {
                                            if (
                                                !result["E-Mail-Adresse"] ||
                                                !isEmail(
                                                    result["E-Mail-Adresse"]
                                                )
                                            ) {
                                                alert(
                                                    "E-Mail Adresse fehlt oder ist in einer der Zeilen falsch "
                                                );

                                                throw new Error(
                                                    "E-Mail Adresse fehlt oder ist in einer der Zeilen falsch"
                                                );
                                            }
                                            return {
                                                email: result["E-Mail-Adresse"],
                                                firstName: result.Vorname,
                                                lastName: result.Name,
                                                userInputedInsuranceName:
                                                    result[
                                                        "Deine Krankenkasse?"
                                                    ],
                                            };
                                        }
                                    );
                                setTestUsers(serverResults);
                            }}
                        >
                            {({
                                getRootProps,
                                acceptedFile,
                                ProgressBar,
                                getRemoveFileProps,
                            }: any) => {
                                const props = { ...getRemoveFileProps() };

                                return (
                                    <>
                                        <div style={styles.csvReader}>
                                            <button
                                                type="button"
                                                {...getRootProps()}
                                                style={styles.browseFile}
                                            >
                                                Browse file
                                            </button>
                                            <div style={styles.acceptedFile}>
                                                {acceptedFile &&
                                                    acceptedFile.name}
                                            </div>
                                            <button
                                                {...props}
                                                onClick={(event: Event) => {
                                                    props.onClick(event);
                                                    setTestUsers([]);
                                                }}
                                                style={styles.remove}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                        <ProgressBar
                                            style={
                                                styles.progressBarBackgroundColor
                                            }
                                        />
                                    </>
                                );
                            }}
                        </CSVReader>
                    </div>
                    <div className="add-test-user-submit-cont">
                        {!loading ? (
                            <Button
                                onClick={() => {
                                    if (testUsers.length > 200) {
                                        messageContext.actions.setMessage({
                                            title: "Es ist leider nur möglich bis zu 200 Tester gleichzeitig hinzuzufügen. Bitte teilen Sie die .csv-Datei auf.",
                                            isOpen: true,
                                            titleApparencce: "danger",
                                            buttons: [
                                                {
                                                    buttonText: "OK",
                                                    onClick: () =>
                                                        messageContext.actions.closeModal(),
                                                },
                                            ],
                                        });

                                        return;
                                    }
                                    setIsLoading(true);
                                    API.handlePostRequest<
                                        ServerCSVData[],
                                        ServerCSVData[]
                                    >(testUsers, `/users/addTestUsers`, {
                                        timeout: 5000000,
                                    })
                                        .then((res) => {
                                            setIsLoading(false);
                                            if (res.length < 1) {
                                                alert(
                                                    "Die Testnutzer wurden erfolgreich hinzugefügt."
                                                );
                                                // eslint-disable-next-line no-restricted-globals
                                                location.reload();
                                            } else {
                                                alert(
                                                    "Beim Hinzufügen der Testnutzer ist ein Fehler aufgetreten!"
                                                );
                                                setFailedEmail(
                                                    res
                                                        .map(
                                                            (failed) =>
                                                                failed.email
                                                        )
                                                        .toString()
                                                );
                                            }
                                        })
                                        .catch((err) => {
                                            setIsLoading(false);
                                            alert(
                                                "Beim Hinzufügen der Testnutzer ist ein Fehler aufgetreten!"
                                            );
                                        });
                                }}
                                appearance="primary"
                                isDisabled={testUsers.length < 1}
                            >
                                Absenden
                            </Button>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <div style={{ width: 50 }}>
                                    <Loader />
                                </div>
                                <div>
                                    Die Testnutzer werden hochgeladen. Dieser
                                    Vorgang kann einige Minuten dauern. Bitte
                                    schließen Sie die Seite während des Uploads
                                    nicht.
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {failedEmail && (
                <div className="submit">
                    Für E-Mails fehlgeschlagen: {failedEmail}
                </div>
            )}
        </div>
    );
}
